import { render, staticRenderFns } from "./SelectCategories.vue?vue&type=template&id=2724f266&"
import script from "./SelectCategories.vue?vue&type=script&lang=js&"
export * from "./SelectCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports